export default {
  USER_LOADING: 'USER_LOADING',
  FETCH_USERS: 'FETCH_USERS',
  FETCH_USERS_SUCCESSY: 'FETCH_USERS_SUCCESSY',
  FETCH_USERS_FAILED: 'FETCH_USERS_FAILED',
  FETCH_USERS_REJECT: 'FETCH_USERS_REJECT',
  FETCH_USER_BY_ID: 'FETCH_USER_BY_ID',
  FETCH_USER_BY_ID_SUCCESSY: 'FETCH_USER_BY_ID_SUCCESSY',
  FETCH_USER_BY_ID_FAILED: 'FETCH_USER_BY_ID_FAILED',
  FETCH_USER_BY_ID_REJECT: 'FETCH_USER_BY_ID_REJECT',
  USER_BY_ID_LOADING: 'USER_BY_ID_LOADING',

  FETCH_ALL_USER_DETAILS_FAILED: 'FETCH_ALL_USER_DETAILS_FAILED',
  FETCH_ALL_USER_DETAILS_REJECT: 'FETCH_ALL_USER_DETAILS_REJECT',
  FETCH_ALL_USER_DETAILS_LOADING: 'FETCH_ALL_USER_DETAILS_LOADING',
  FETCH_ALL_USER_DETAILS_SUCCESS: 'FETCH_ALL_USER_DETAILS_SUCCESS',


  CREATE_NEW_USER_FAILED: 'CREATE_NEW_USER_FAILED',
  CREATE_NEW_USER_REJECT: 'CREATE_NEW_USER_REJECT',
  CREATE_NEW_USER_LOADING: 'CREATE_NEW_USER_LOADING',
  CREATE_NEW_USER_SUCCESS: 'CREATE_NEW_USER_SUCCESS',


  UPDATE_USER_FAILED: 'UPDATE_USER_FAILED',
  UPDATE_USER_REJECT: 'UPDATE_USER_REJECT',
  UPDATE_USER_LOADING: 'UPDATE_USER_LOADING',
  UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS'
};
